(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fyela-home"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('fyela-home')){customElements.define('fyela-home',class extends HTMLElement{connectedCallback(){if(this._fyReady)return;this._fyReady=true;this.addEventListener('click',event=>{const button=event.target.closest('[data-fy-target]');if(!button||!this.contains(button))return;const target=button.dataset.fyTarget;this.querySelectorAll('[data-fy-slide]').forEach(slide=>{slide.hidden=slide.id!==target});this.querySelectorAll('[data-fy-target]').forEach(control=>{control.setAttribute('aria-pressed',String(control===button))})})}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
